module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"budgetdetails.title":"Budget Details - {budgetName}","budgetdetails.chartTitle":"Budget Periods","budgetdetails.backButton":"Back to Budgets","budgetdetails.table.period":"Budget Period","budgetdetails.table.amount":"Budget Amount","budgetdetails.table.actual":"Actual Spend","budgetdetails.table.varianceamount":"Delta Amount","budgetdetails.table.variancepercentage":"Delta %"}}')
  delete Component.options._Ctor
}
